import {IProps} from "app/common/SimpleDialog/types";

/**
 * Purpose of these "Actions" is to mimic a more redux-style of event management, which
 * should make transitioning to redux a little easier when the time comes.
 */

const NS = 'SimpleDialogActions';

export enum SimpleDialogActionNames {
  SHOW_SIMPLE_DIALOG = 'SHOW_SIMPLE_DIALOG',
  HIDE_SIMPLE_DIALOG = 'HIDE_SIMPLE_DIALOG'
}

class SimpleDialogActions {

  private $rootScope: any;

  setup($rootScope: any) {
    this.$rootScope = $rootScope;
  }

  hideDialog(): void {
    this.$rootScope.$broadcast(SimpleDialogActionNames.HIDE_SIMPLE_DIALOG);
  }

  showDialog(props: IProps): void {
    this.$rootScope.$broadcast(SimpleDialogActionNames.SHOW_SIMPLE_DIALOG, { payload: props as IProps });
  }

  handleShowDialog(callback: (props: IProps) => void) {
      this.$rootScope.$on(SimpleDialogActionNames.SHOW_SIMPLE_DIALOG, (evt: any, {payload}: {payload: IProps}) => {
      callback(payload);
    });
  }

  handleHideDialog(callback: () => void) {
    this.$rootScope.$on(SimpleDialogActionNames.HIDE_SIMPLE_DIALOG, (evt: any) => {
      callback();
    });
  }
}


const instance = new SimpleDialogActions();
export default instance as SimpleDialogActions;
